export default __webpack_public_path__ + "static/media/approvedIcon.c388d656.svg";